import {
  CmpTypographyField,
  CmpTextField,
  CmpSelectBox,
  CmpDatePicker,
} from "../../../Component/Common/ToolBox/ToolBox";
import Grid from "@mui/material/Grid";
import {
  CmpDatePickerField001V1,
  CmpSelectArrFieldV1,
  CmpSelectFieldV1,
  CmpTextFieldV1,
} from "../../../Component/Common/ToolBox/ToolBoxV1";
export default function GcHead({ 
  vRdxHead, 
  fDate,
  sDetail_Grid_Row,
  fKeyTabInput,
  vRdxHeadDetail
}) {
  return (
    <form id="WmsStockAdjustmentHead">
      <Grid
        container
        rowSpacing={{ xs: 4, sm: 2, md: 2 }}
        columnSpacing={{ xs: 0, sm: 0, md: 0 }}
        columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
        // className="align-items-center"
      >
        <Grid item xs={12} sm={12} md={6}>
          <Grid container spacing={0.9} columns={{ xs: 12, sm: 12, md: 12 }}>
            <Grid item xs={6} sm={6} md={6}>
              <CmpTextFieldV1
                xLabelText="Document"
                xSize="small"
                xValue={vRdxHead.VocName}
                xType={"text"} // text/number/password
                xName={"VocName"}
                xReadOnly={true}
                xOnChange={""}
                xError={  false  }
                xErrorMessage={""}
                xOnKeyUp={(e) => {
                  fKeyTabInput(e, "A_VocNo");
                }}
              />
            </Grid>

            <Grid item xs={6} sm={6} md={3}>
              <CmpTextFieldV1
                xLabelText="Doc.No"
                xSize="small"
                xValue={vRdxHead.A_VocNo}
                xType={"text"} // text/number/password
                xName={"A_VocNo"}
                xReadOnly={true}
                xOnChange={""}
                xError={  false  }
                xErrorMessage={""}
                xOnKeyUp={(e) => {
                  fKeyTabInput(e, "A_PostDt");
                }}
              />
            </Grid>

            <Grid item xs={6} sm={6} md={3}>
              <CmpDatePickerField001V1
                xLabelText="Date"
                xtabIndex={"2"}
                // xValue={vRdxWmsHead.A_PostDt}
                xValue={vRdxHead.A_PostDt}
                xOnChange={()=>{}}
                xName={"A_PostDt"}
                xError={  false  }
                xErrorMessage={""}
                xDisable={true}
                // xOnKeyUp={(e) => {
                //   xFocusInput("A_RefDocNo");
                // }}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={3}>
              <CmpDatePickerField001V1
                xLabelText="Dispatch.Date"
                xtabIndex={"2"}
                // xValue={vRdxWmsHead.A_PostDt}
                xValue={vRdxHeadDetail?.DeptDate1}
                xOnChange={fDate}
                xName={"DeptDate1"}
                xError={  false  }
                xErrorMessage={""}
                xDisable={sDetail_Grid_Row.length > 0}
                // xOnKeyUp={(e) => {
                //   xFocusInput("A_RefDocNo");
                // }}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={3}>
            
              <CmpTextFieldV1
                xLabelText="Version"
                xSize="small"
                xValue={vRdxHeadDetail.Version}
                xType={"text"} // text/number/password
                xName={"Version"}
                xReadOnly={true}
                xOnChange={""}
                xError={  false  }
                xErrorMessage={""}
                xOnKeyUp={(e) => {
                  fKeyTabInput(e, "Party");
                }}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={6}>
          <Grid container spacing={0.9} columns={{ xs: 12, sm: 12, md: 12 }}>
            <Grid item xs={6} sm={6} md={3}>
              <CmpTextFieldV1
                xLabelText="Party"
                xSize="small"
                xValue={vRdxHead.A_Party}
                xType={"text"} // text/number/password
                xName={"A_Party"}
                xReadOnly={true}
                xOnChange={""}
                xError={  false  }
                xErrorMessage={""}
                xOnKeyUp={(e) => {
                  fKeyTabInput(e, "PartyName");
                }}
              />
            </Grid>
           

            <Grid item xs={6} sm={6} md={9}>
              <CmpTextFieldV1
                xLabelText="Party.Name"
                xSize="small"
                xValue={vRdxHead.PartyName}
                xType={"text"} // text/number/password
                xName={"PartyName"}
                xReadOnly={true}
                xOnChange={""}
                xError={  false  }
                xErrorMessage={""}
                xOnKeyUp={(e) => {
                  fKeyTabInput(e, "BrName");
                }}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={3}>
            {/* <CmpSelectFieldV1
                xLabelText="Branch"
                xValue={vRdxHead.A_Br}
                xOnChange={(e) => {}}
                xName={"A_Br"}
                xData={[]}
                xValueMember={""}
                xDispalyMember={""}
                xError={  false  }
                xErrorMessage={""}
                xDisable={false}
              /> */}
               <CmpTextFieldV1
                xLabelText="Branch"
                xSize="small"
                xValue={vRdxHead.BrName}
                xType={"text"} // text/number/password
                xName={"BrName"}
                xReadOnly={true}
                xOnChange={""}
                xError={  false  }
                xErrorMessage={""}
                xOnKeyUp={(e) => {
                  fKeyTabInput(e, "A_Br");
                }}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={3}>
            {/* <CmpSelectFieldV1
                xLabelText="Branch"
                xValue={vRdxHead.A_Br}
                xOnChange={(e) => {}}
                xName={"A_Br"}
                xData={[]}
                xValueMember={""}
                xDispalyMember={""}
                xError={  false  }
                xErrorMessage={""}
                xDisable={false}
              /> */}
               <CmpTextFieldV1
                xLabelText="Location"
                xSize="small"
                xValue={vRdxHead.LocName}
                xType={"text"} // text/number/password
                xName={"LocName"}
                xReadOnly={true}
                xOnChange={""}
                xError={  false  }
                xErrorMessage={""}
                xOnKeyUp={(e) => {
                  fKeyTabInput(e, "TrnTypName");
                }}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={3}>
            <CmpTextFieldV1
                xLabelText="Transaction"
                xSize="small"
                xValue={vRdxHead.TrnTypName}
                xType={"text"} // text/number/password
                xName={"TrnTypName"}
                xReadOnly={true}
                xOnChange={""}
                xError={  false  }
                xErrorMessage={""}
                xOnKeyUp={(e) => {
                  fKeyTabInput(e, "A_PostDt");
                }}
              />
            </Grid>
            
          </Grid>
        </Grid>
      </Grid>
    </form>
  );
}
